export default "__VITE_ASSET__34810ac3__"